<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <v-text-field
            label="Busca"
            v-model="filter"
            outlined
            dense
            hide-details
            append-icon="eva-search-outline"
            clearable
            background-color="white"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-dialog v-model="dialog" max-width="700px" @click:outside="close">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
                Novo Cid
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="headline">Novo Cid</span>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row dense>
                    <v-col cols="4">
                      <v-text-field
                        outlined
                        dense
                        v-model="cid.code"
                        label="Codigo"
                        :hide-details="!errors.cid"
                        :error-messages="errors.cid"
                      />
                    </v-col>

                    <v-col>
                      <v-text-field
                        outlined
                        dense
                        v-model="cid.description"
                        label="Descrição"
                        :hide-details="!errors.cid"
                        :error-messages="errors.cid"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-pagination
            v-model="page"
            :length="numberOfPages"
            :total-visible="7"
          />
        </v-col>
      </v-row>

      <v-row dense v-for="cid in cidsPage" :key="cid.id">
        <v-col>
          <CidListItem :cid="cid" :refreshList="refreshList" />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-pagination
            v-model="page"
            :length="numberOfPages"
            :total-visible="7"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import CidListItem from "@/components/config/diagnostic_hypothesis/cid/item/index.vue";

export default {
  name: "CidList",
  components: {
    CidListItem,
  },
  data() {
    return {
      errors: {},
      page: 1,
      dialog: null,
      cid: {},
      itemsPerPage: 10,
      cids: [],
      filter: "",
    };
  },
  apollo: {
    cids: {
      query: require("@/graphql/cids.gql"),
    },
  },
  computed: {
    filteredCids() {
      let cids = this.lodash.orderBy(
        this.cids,
        (e) => {
          let cidName = `${e.code} - ${e.description}`;

          return cidName
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
        },
        ["asc"]
      );

      if (this.filter) {
        cids = this.lodash.filter(
          cids,
          function (e) {
            let cidName = `${e.code} - ${e.description}`;

            return cidName
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return cids;
    },
    numberOfPages() {
      let numberOfPages = Math.floor(
        this.filteredCids.length / this.itemsPerPage
      );

      if (numberOfPages < 1) {
        numberOfPages += 1;
      }

      return numberOfPages;
    },
    cidsPage() {
      let startPos = this.page * this.itemsPerPage;
      let endPos = startPos + this.itemsPerPage;

      return this.lodash.slice(this.filteredCids, startPos, endPos);
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.medicine = {};
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/diagnostic_hypothesis/save_cid.gql"),
        variables: {
          cidId: "",
          code: this.cid.code,
          description: this.cid.description,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      this.$apollo.queries.cids.refetch();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let code = this.cid.code;
      if (this.lodash.isEmpty(code?.trim())) {
        this.errors.cid = errorMsg;
      }

      let description = this.cid.description;
      if (this.lodash.isEmpty(description?.trim())) {
        this.errors.cid = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
